if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('[data-fancybox]').fancybox({
        toolbar  : false,
        smallBtn : true
    });


    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // NAV IMAGES
    document.querySelectorAll('.main-menu').forEach(mod => {
        mod.querySelectorAll('.privary-navigation__list > li').forEach((btn, i) => {
            const itemImage = document.querySelectorAll('.main-menu__pics img')[i];

            // SET ACTIVE IMAGE
            if ( btn.querySelector('a').classList.contains('active') && itemImage ) itemImage.classList.add('active');

            if ( btn.querySelector('a').classList.contains('parent-active') && itemImage ) itemImage.classList.add('active');

            // TOGGLE HOVER CLASS
            btn.addEventListener('mouseenter', () => { if ( itemImage ) itemImage.classList.add('hover'); });
            btn.addEventListener('mouseleave', () => { if ( itemImage ) itemImage.classList.remove('hover'); });
        });

        // FALLBACK ACTIVE IMAGE
        if (document.querySelector('.main-menu__pics') && document.querySelectorAll('.main-menu__pics .active').length < 1) document.querySelectorAll('.main-menu__pics img')[0].classList.add('active');
    });

    document.querySelector('.js-open-menu').addEventListener('click', function(){
        document.querySelector('#main-nav').classList.add('show');
    });

    document.querySelector('.js-close-menu').addEventListener('click', function(){
        document.querySelector('#main-nav').classList.remove('show');
    });

    $('.cards__slider').slick({
        arrows: true,
        dots: false,
        slidesToShow:3,
        speed: 700,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    centerMode: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    centerMode: true
                }
            }
        ]
    });

    if(document.querySelector('.gallery-home')){
        $('.gallery-home__left').slick({
            arrows: true,
            dots: false,
            infinite: true,
            slidesToShow: 2,
            variableWidth: true,
            fade: false,
            rtl: true,
            asNavFor: '.gallery-home__right',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        centerMode: true
                    }
                }
            ]
        });

        $('.gallery-home__right').slick({
            arrows: false,
            dots: false,
            infinite: true,
            variableWidth: true,
            fade: false,
            rtl: true
        })
    }

    if(document.querySelector('.gallery-internal')){
        $('.gallery-internal__left').slick({
            arrows: false,
            dots: false,
            infinite: true,
            variableWidth: true,
            fade: false
        });

        $('.gallery-internal__right').slick({
            arrows: true,
            dots: false,
            infinite: true,
            slidesToShow: 2,
            variableWidth: true,
            fade: false,
            asNavFor: '.gallery-internal__left',
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        centerMode: true,
                        slidesToShow: 1,
                        asNavFor: null
                    }
                }
            ]
        })
    }

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    
    }

    // WRAP MODULE TABLES
    if (!document.getElementsByClassName('real-estate').length){
        document.querySelectorAll('.form-module-wrapper').forEach((form) => {
            const tableWrapper = document.createElement('div');
            tableWrapper.classList.add('form-module-wrapper__container','animate-fade','top');
            let confirmation = form.querySelector('.form-module__confirmation');
            let contentForm = form.querySelector('.form-module');
            form.appendChild(tableWrapper);
            tableWrapper.appendChild(confirmation);
            tableWrapper.appendChild(contentForm);
        });
    }

    document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((text)=>{
        text.classList.add('animate-fade','top');
    })

    if(window.innerWidth > 1025){
        // VALIDATE PRIMARY SUBNAVs
        document.querySelectorAll('.privary-navigation__item').forEach((item) => {
            if (item.querySelectorAll('.submenu').length > 0) {
                item.classList.add('has-submenu');
            }
        });
}

    if(document.querySelector('.top-content__hovers')){
        let listItems = document.querySelectorAll('.top-content__hovers ul li');
        let urlSet = document.querySelector('.top-content__slider .slide img').getAttribute('src');
        listItems.forEach((item)=>{
            let url = item.dataset.src;
            if( url ){
                item.addEventListener('mouseover', ()=>{
                    document.querySelector('.top-content__slider .slide').classList.add('opacity');
                    document.querySelector('.top-content__slider .slide img').src = url;
                    setTimeout(() => {
                        document.querySelector('.top-content__slider .slide').classList.remove('opacity');
                    }, 200);
                    listItems.forEach((btn)=>{
                        btn.classList.remove('active');
                    })
                    item.classList.add('active');
                });
            }
        })
    }

    $('.accommodations-home__slider').slick({
        arrows: true,
        dots: false,
        autoplay: false,
        speed: 700,
        fade: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 5000
                }
            }
        ]
    });
    
})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
    const menu = document.querySelector('.main-menu ');
    const isMenuVisible = menu && menu.classList.contains('show');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.main-menu ');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});
